<script setup lang="ts">
import { appConfig } from '../../legacy/lib/config/app-config';
import LinkButton from '../../legacy/ui/button/link-button.vue';
import { useI18N } from '../../legacy/lib/use-i18n';
import { toMailto } from '../../legacy/lib/util/mailto-helper';

const { mailSubject, mailBody } = defineProps<{
  color?: string;
  size?: string;
  mailSubject: string;
  mailBody: string;
}>();
const i18n = useI18N();
const mailto = toMailto(appConfig.get('supportEmail'), {
  subject: mailSubject,
  body: mailBody
});
</script>

<template>
  <link-button
    data-qa="ask-plug-button"
    :color="color"
    type="link"
    :to="mailto"
    :size="size"
  >
    {{ i18n('ask') }}
  </link-button>
</template>

<style scoped>
</style>

<i18n lang="json">
{
  "ask": {
    "ru_RU": "Попросить настроить",
    "en_US": "Ask to enable"
  }
}
</i18n>
